/*!
 * SilkCo sale-price mirror — PRODUCT PAGE VARIANT HANDLER
 * ---------------------------------------------------------------------------
 * The server-rendered Liquid (snippets/silkco-sale-calc.liquid) shows the
 * correct discounted price on first paint and on all collection/listing cards.
 *
 * On a PRODUCT page, the theme rewrites the price when the shopper switches
 * variant — using the raw variant price, which undoes our discount. This
 * script re-applies the same percentage after every variant change so the
 * strikethrough sale price stays correct.
 *
 * It only acts on price blocks that Liquid marked with data-silkco-percent,
 * so non-sale products and the "toggle off" state are never touched.
 * ---------------------------------------------------------------------------
 */
(function () {
  "use strict";

  function money(cents, format) {
    if (window.theme && theme.Helpers && theme.Helpers.formatMoney) {
      return theme.Helpers.formatMoney(cents, format);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  // Discount rounded to the nearest cent, then subtracted — matches the way
  // Shopify rounds a percentage automatic discount.
  function discounted(base, pct) {
    return base - Math.round((base * pct) / 100);
  }

  function findVariantInput(el) {
    var node = el;
    while (node && node !== document.body) {
      if (node.querySelector) {
        var input = node.querySelector('[name="id"]');
        if (input) return input;
      }
      node = node.parentNode;
    }
    return document.querySelector('[name="id"]');
  }

  function setup(container) {
    var pct = parseInt(container.getAttribute("data-silkco-percent"), 10) || 0;
    if (!pct) return;

    var format = container.getAttribute("data-silkco-money-format") || "${{amount}}";

    var variants = [];
    try {
      var node = container.querySelector("[data-silkco-variants]");
      if (node) variants = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    var idInput = findVariantInput(container);
    var regEl = container.querySelector(".price__regular .price-item--regular");
    var saleEl = container.querySelector(".price__sale .price-item--sale");
    var saleRegEl = container.querySelector(".price__sale .price-item--regular");
    if (!idInput) return;

    var observer = null;
    var lastKey = "";

    function apply() {
      var vid = String(idInput.value || "");
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === vid) { v = variants[i]; break; }
      }
      if (!v) return;

      var base = v.price;
      var comp = (v.compare_at_price && v.compare_at_price > base) ? v.compare_at_price : base;
      var fin = discounted(base, pct);
      var key = vid + ":" + fin + ":" + comp;
      if (key === lastKey) return; // already showing the right thing
      lastKey = key;

      if (observer) observer.disconnect();
      if (regEl) regEl.innerHTML = money(fin, format);
      if (saleEl) saleEl.innerHTML = money(fin, format);
      if (saleRegEl) saleRegEl.innerHTML = money(comp, format);
      container.classList.add("price--on-sale");
      if (observer) observer.observe(container, { childList: true, subtree: true, characterData: true });
    }

    // The theme updates the price on variant change; re-apply on the next
    // frame so we run after it. The lastKey guard prevents loops.
    observer = new MutationObserver(function () {
      lastKey = "";
      window.requestAnimationFrame(apply);
    });
    observer.observe(container, { childList: true, subtree: true, characterData: true });

    window.requestAnimationFrame(apply);
  }

  function init() {
    var containers = document.querySelectorAll("[data-silkco-percent]");
    for (var i = 0; i < containers.length; i++) setup(containers[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();